import * as React from 'react';
import {
  Appearance,
  FlagProps,
} from '@volkswagen-onehub/whitelabel-e-mobility-commons';
import {DisplayTag} from '@volkswagen-onehub/components-core';
import {Icon} from '../icon';

function getFlagIcon(appearance: Appearance, hideIcon?: boolean) {
  if (hideIcon) return undefined;

  switch (appearance) {
    case 'offer':
      return <Icon name="Discount" size="small" />;
    case 'info':
      return <Icon name="Info" size="small" />;
    default:
      return undefined;
  }
}

export function Flag(props: FlagProps): JSX.Element {
  const {appearance, text, hideIcon, testId} = props;

  const icon = getFlagIcon(appearance, hideIcon);

  return (
    <DisplayTag
      appearance={appearance}
      text={text}
      data-testid={testId}
      icon={icon}
    />
  );
}

export function FlagInverted(props: FlagProps): JSX.Element {
  return Flag(props);
}
